module.exports = __webpack_public_path__ + "static/media/trash.60b8140a.svg";